import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import Collection from './components/Projects';

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

export default ({match, regions,roles}) => (

	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
